// extracted by mini-css-extract-plugin
export default {"quizOption":"Quiz_quizOption__6zkww","quizOptionNumber":"Quiz_quizOptionNumber__tEJZa","quizOptionLabel":"Quiz_quizOptionLabel__ouV4q","selected":"Quiz_selected__P2ylW"};